import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const EDUCATION_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [
    'SSC (Secondary School Certificate)',
    'HSC (Higher Secondary Certificate)',
    'Diploma',
    'B.A. (Bachelor of Arts)',
    'B.Sc. (Bachelor of Science)',
    'B.Com. (Bachelor of Commerce)',
    'B.Tech (Bachelor of Technology)',
    'B.E. (Bachelor of Engineering)',
    'MBBS (Bachelor of Medicine, Bachelor of Surgery)',
    'BDS (Bachelor of Dental Surgery)',
    'B.Arch (Bachelor of Architecture)',
    'M.A. (Master of Arts)',
    'M.Sc. (Master of Science)',
    'M.Com. (Master of Commerce)',
    'M.Tech (Master of Technology)',
    'M.E. (Master of Engineering)',
    'MBA (Master of Business Administration)',
    'MD (Doctor of Medicine)',
    'MS (Master of Surgery)',
    'Ph.D. (Doctor of Philosophy)', // Translate till here
    'ITI (Industrial Training Institute)',
    'Polytechnic',
    'BBA (Bachelor of Business Administration)',
    'B.Ed. (Bachelor of Education)',
    'LLB (Bachelor of Laws)',
    'B.Pharm (Bachelor of Pharmacy)',
    'BHMS (Bachelor of Homeopathic Medicine and Surgery)',
    'BAMS (Bachelor of Ayurvedic Medicine and Surgery)',
    'BUMS (Bachelor of Unani Medicine and Surgery)',
    'B.VSc (Bachelor of Veterinary Science)',
    'D.Pharm (Diploma in Pharmacy)',
    'GNM (General Nursing and Midwifery)',
    'ANM (Auxiliary Nurse Midwife)',
    'DMLT (Diploma in Medical Laboratory Technology)',
    'BPT (Bachelor of Physiotherapy)',
    'MPT (Master of Physiotherapy)',
    'M.Ed. (Master of Education)',
    'LLM (Master of Laws)',
    'M.Pharm (Master of Pharmacy)',
    'D.Litt. (Doctor of Literature)',
    'D.Sc. (Doctor of Science)',
  ],
  [SupportedLanguage.Hindi]: [
    'एसएससी (माध्यमिक विद्यालय प्रमाणपत्र)',
    'एचएससी (उच्च माध्यमिक प्रमाणपत्र)',
    'डिप्लोमा',
    'बी.ए. (कला स्नातक)',
    'बी.एससी. (विज्ञान स्नातक)',
    'बी.कॉम. (वाणिज्य स्नातक)',
    'बी.टेक (प्रौद्योगिकी स्नातक)',
    'बी.ई. (इंजीनियरिंग स्नातक)',
    'एमबीबीएस (चिकित्सा स्नातक)',
    'बीडीएस (दंत चिकित्सा स्नातक)',
    'बी.आर्क (वास्तुकला स्नातक)',
    'एम.ए. (कला स्नातकोत्तर)',
    'एम.एससी. (विज्ञान स्नातकोत्तर)',
    'एम.कॉम. (वाणिज्य स्नातकोत्तर)',
    'एम.टेक (प्रौद्योगिकी स्नातकोत्तर)',
    'एम.ई. (इंजीनियरिंग स्नातकोत्तर)',
    'एमबीए (व्यवसाय प्रशासन स्नातकोत्तर)',
    'एमडी (चिकित्सा स्नातकोत्तर)',
    'एमएस (शल्य चिकित्सा स्नातकोत्तर)',
    'पीएच.डी. (डॉक्टर ऑफ फिलॉसफी)',
    'आईटीआई (औद्योगिक प्रशिक्षण संस्थान)',
    'पॉलिटेक्निक',
    'बीबीए (व्यवसाय प्रशासन स्नातक)',
    'बी.एड. (शिक्षा स्नातक)',
    'एलएलबी (कानून स्नातक)',
    'बी.फार्म (फार्मेसी स्नातक)',
    'बीएचएमएस (होम्योपैथिक चिकित्सा और सर्जरी स्नातक)',
    'बीएएमएस (आयुर्वेदिक चिकित्सा और सर्जरी स्नातक)',
    'बीयूएमएस (यूनानी चिकित्सा और सर्जरी स्नातक)',
    'बी.वी.एससी (पशु चिकित्सा विज्ञान स्नातक)',
    'डी.फार्म (फार्मेसी में डिप्लोमा)',
    'जीएनएम (सामान्य नर्सिंग और मिडवाइफरी)',
    'एएनएम (सहायक नर्स मिडवाइफ)',
    'डीएमएलटी (चिकित्सा प्रयोगशाला प्रौद्योगिकी में डिप्लोमा)',
    'बीपीटी (फिजियोथेरेपी स्नातक)',
    'एमपीटी (फिजियोथेरेपी में मास्टर)',
    'एम.एड. (शिक्षा में मास्टर)',
    'एलएलएम (कानून में मास्टर)',
    'एम.फार्म (फार्मेसी में मास्टर)',
    'डी.लिट. (साहित्य में डॉक्टर)',
    'डी.एससी. (विज्ञान में डॉक्टर)',
  ],
  [SupportedLanguage.Marathi]: [
    'एसएससी (माध्यमिक शाळा प्रमाणपत्र)',
    'एचएससी (उच्च माध्यमिक प्रमाणपत्र)',
    'डिप्लोमा',
    'बी.ए. (कला शाखेतील पदवी)',
    'बी.एस्सी. (विज्ञान शाखेतील पदवी)',
    'बी.कॉम. (वाणिज्य शाखेतील पदवी)',
    'बी.टेक (तंत्रज्ञान शाखेतील पदवी)',
    'बी.ई. (अभियांत्रिकी शाखेतील पदवी)',
    'एमबीबीएस (वैद्यकीय शाखेतील पदवी)',
    'बीडीएस (दंतवैद्यक शाखेतील पदवी)',
    'बी.आर्क (वास्तुकला शाखेतील पदवी)',
    'एम.ए. (कला शाखेतील पदव्युत्तर)',
    'एम.एस्सी. (विज्ञान शाखेतील पदव्युत्तर)',
    'एम.कॉम. (वाणिज्य शाखेतील पदव्युत्तर)',
    'एम.टेक (तंत्रज्ञान शाखेतील पदव्युत्तर)',
    'एम.ई. (अभियांत्रिकी शाखेतील पदव्युत्तर)',
    'एमबीए (व्यवस्थापन शाखेतील पदव्युत्तर)',
    'एमडी (वैद्यकीय शाखेतील पदव्युत्तर)',
    'एमएस (शल्यचिकित्सा शाखेतील पदव्युत्तर)',
    'पीएच.डी. (तत्त्वज्ञान शाखेतील डॉक्टरेट)',
  ],
  [SupportedLanguage.Gujarati]: [
    'એસએસસી (માધ્યમિક શાળા પ્રમાણપત્ર)',
    'એચએસસી (ઉચ્ચ માધ્યમિક પ્રમાણપત્ર)',
    'ડિપ્લોમા',
    'બી.એ. (કલાસ્નાર્થી)',
    'બી.એસસી. (વિજ્ઞાનનો સ્નાતક)',
    'બી.કોમ. (વાણિજ્યનો સ્નાતક)',
    'બી.ટેક (ટેકનોલોજીનો સ્નાતક)',
    'બી.ઈ. (ઈજનેરીનો સ્નાતક)',
    'એમબીબીએસ (મેડિસિન અને સર્જરીનો સ્નાતક)',
    'બીડીએસ (ડેન્ટલ સર્જરીનો સ્નાતક)',
    'બી.આર્ક (આર્કિટેક્ચરનો સ્નાતક)',
    'એમ.એ. (કલાસ્નાર્થી)',
    'એમ.એસસી. (વિજ્ઞાનનો માસ્ટર)',
    'એમ.કોમ. (વાણિજ્યનો માસ્ટર)',
    'એમ.ટેક (ટેકનોલોજીનો માસ્ટર)',
    'એમ.ઈ. (ઈજનેરીનો માસ્ટર)',
    'એમબીએ (બિઝનેસ એડમિનિસ્ટ્રેશનનો માસ્ટર)',
    'એમડી (મેડિસિનનો ડોક્ટર)',
    'એમએસ (સર્જરીનો માસ્ટર)',
    'પીએચ.ડી. (દર્શનશાસ્ત્રનો ડોક્ટર)',
  ],
  [SupportedLanguage.Bengali]: [
    'এসএসসি (মাধ্যমিক স্কুল সার্টিফিকেট)',
    'এইচএসসি (উচ্চ মাধ্যমিক সার্টিফিকেট)',
    'ডিপ্লোমা',
    'বি.এ. (ব্যাচেলর অব আর্টস)',
    'বি.এসসি. (ব্যাচেলর অব সায়েন্স)',
    'বি.কম. (ব্যাচেলর অব কমার্স)',
    'বি.টেক (ব্যাচেলর অব টেকনোলজি)',
    'বি.ই. (ব্যাচেলর অব ইঞ্জিনিয়ারিং)',
    'এমবিবিএস (ব্যাচেলর অব মেডিসিন, ব্যাচেলর অব সার্জারি)',
    'বিডিএস (ব্যাচেলর অব ডেন্টাল সার্জারি)',
    'বি.আর্ক (ব্যাচেলর অব আর্কিটেকচার)',
    'এম.এ. (মাস্টার অব আর্টস)',
    'এম.এসসি. (মাস্টার অব সায়েন্স)',
    'এম.কম. (মাস্টার অব কমার্স)',
    'এম.টেক (মাস্টার অব টেকনোলজি)',
    'এম.ই. (মাস্টার অব ইঞ্জিনিয়ারিং)',
    'এমবিএ (মাস্টার অব বিজনেস অ্যাডমিনিস্ট্রেশন)',
    'এমডি (ডক্টর অব মেডিসিন)',
    'এমএস (মাস্টার অব সার্জারি)',
    'পিএইচ.ডি. (ডক্টর অব ফিলোসফি)',
  ],
  [SupportedLanguage.Telugu]: [
    'ఎస్సెస్సీ (సెకండరీ స్కూల్ సర్టిఫికేట్)',
    'హెచ్‌ఎస్సీ (హయ్యర్ సెకండరీ సర్టిఫికేట్)',
    'డిప్లొమా',
    'బి.ఎ. (బాచిలర్ ఆఫ్ ఆర్ట్స్)',
    'బి.ఎస్సీ (బాచిలర్ ఆఫ్ సైన్స్)',
    'బి.కామ్ (బాచిలర్ ఆఫ్ కామర్స్)',
    'బి.టెక్ (బాచిలర్ ఆఫ్ టెక్నాలజీ)',
    'బి.ఇ. (బాచిలర్ ఆఫ్ ఇంజనీరింగ్)',
    'ఎంబీబీఎస్ (బాచిలర్ ఆఫ్ మెడిసిన్, బాచిలర్ ఆఫ్ సర్జరీ)',
    'బి.డిఎస్ (బాచిలర్ ఆఫ్ డెంటల్ సర్జరీ)',
    'బి.ఆర్క్ (బాచిలర్ ఆఫ్ ఆర్కిటెక్చర్)',
    'ఎం.ఎ. (మాస్టర్ ఆఫ్ ఆర్ట్స్)',
    'ఎం.ఎస్సీ (మాస్టర్ ఆఫ్ సైన్స్)',
    'ఎం.కామ్ (మాస్టర్ ఆఫ్ కామర్స్)',
    'ఎం.టెక్ (మాస్టర్ ఆఫ్ టెక్నాలజీ)',
    'ఎం.ఇ. (మాస్టర్ ఆఫ్ ఇంజనీరింగ్)',
    'ఎంబీఏ (మాస్టర్ ఆఫ్ బిజినెస్ అడ్మినిస్ట్రేషన్)',
    'ఎం.డి. (డాక్టర్ ఆఫ్ మెడిసిన్)',
    'ఎం.ఎస్ (మాస్టర్ ఆఫ్ సర్జరీ)',
    'పిహెచ్.డి. (డాక్టర్ ఆఫ్ ఫిలాసఫీ)',
  ],
  [SupportedLanguage.Kannada]: [
    'ಎಸ್‌ಎಸ್‌ಸಿ (Secondary School Certificate)',
    'ಎಚ್‌ಎಸ್‌ಸಿ (Higher Secondary Certificate)',
    'ಡಿಪ್ಲೊಮಾ',
    'ಬಿ.ಎ. (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಆರ್ಟ್ಸ್)',
    'ಬಿ.ಎಸ್‌ಸಿ (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಸೈನ್ಸ್)',
    'ಬಿ.ಕಾಂ (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಕಾಮರ್ಸ್)',
    'ಬಿ.ಟೆಕ್ (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಟೆಕ್ನಾಲಜಿ)',
    'ಬಿ.ಇ. (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಎಂಜಿನಿಯರಿಂಗ್)',
    'ಎಂಬಿಬಿಎಸ್ (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಮೆಡಿಸಿನ್, ಬ್ಯಾಚುಲರ್ ಆಫ್ ಸರ್ಜರಿ)',
    'ಬಿಡಿಎಸ್ (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಡೆಂಟಲ್ ಸರ್ಜರಿ)',
    'ಬಿ.ಆರ್ಚ್ (ಬ್ಯಾಚುಲರ್ ಆಫ್ ಆರ್ಕಿಟೆಕ್ಚರ್)',
    'ಎಂ.ಎ. (ಮಾಸ್ಟರ್ ಆಫ್ ಆರ್ಟ್ಸ್)',
    'ಎಂ.ಎಸ್‌ಸಿ (ಮಾಸ್ಟರ್ ಆಫ್ ಸೈನ್ಸ್)',
    'ಎಂ.ಕಾಂ (ಮಾಸ್ಟರ್ ಆಫ್ ಕಾಮರ್ಸ್)',
    'ಎಂ.ಟೆಕ್ (ಮಾಸ್ಟರ್ ಆಫ್ ಟೆಕ್ನಾಲಜಿ)',
    'ಎಂ.ಇ. (ಮಾಸ್ಟರ್ ಆಫ್ ಎಂಜಿನಿಯರಿಂಗ್)',
    'ಎಂಬಿಎ (ಮಾಸ್ಟರ್ ಆಫ್ ಬಿಸಿನೆಸ್ ಅಡ್ಮಿನಿಸ್ಟ್ರೇಷನ್)',
    'ಎಂ.ಡಿ. (ಡಾಕ್ಟರ್ ಆಫ್ ಮೆಡಿಸಿನ್)',
    'ಎಂ.ಎಸ್. (ಮಾಸ್ಟರ್ ಆಫ್ ಸರ್ಜರಿ)',
    'ಪಿಹೆಚ್‌.ಡಿ. (ಡಾಕ್ಟರ್ ಆಫ್ ಫಿಲಾಸಫಿ)',
  ],
  [SupportedLanguage.Tamil]: [
    'எஸ்எஸ்சி (மெடிக்கல் கல்லூரி சான்றிதழ்)',
    'எச்ச்எஸ்சி (உயர்நிலை மெடிக்கல் கல்லூரி சான்றிதழ்)',
    'டிப்ளோமா',
    'பி.ஏ. (கலை பட்சத்திரம்)',
    'பி.எஸ்சி. (அறிவியல் பட்சத்திரம்)',
    'பி.காம். (வணிக பட்சத்திரம்)',
    'பி.டெக் (தொழில்நுட்ப பட்சத்திரம்)',
    'பி.இ. (பொறியியல் பட்சத்திரம்)',
    'எம்பிபிபிஎஸ் (மருத்துவ பட்சத்திரம், அறுவை மருத்துவம்)',
    'பிடிஎஸ் (பல் மருத்துவம்)',
    'பி.ஆர்ச் (கட்டிடக்கலை பட்சத்திரம்)',
    'எம்.ஏ. (கலை மாஸ்டர்)',
    'எம்.எஸ்சி. (அறிவியல் மாஸ்டர்)',
    'எம்.காம். (வணிக மாஸ்டர்)',
    'எம்.டெக் (தொழில்நுட்ப மாஸ்டர்)',
    'எம்.இ. (பொறியியல் மாஸ்டர்)',
    'எம்பிஏ (வணிக நிர்வாக மாஸ்டர்)',
    'எம்டி (மருத்துவ மாஸ்டர்)',
    'எம்எஸ் (அறுவை மருத்துவம்)',
    'பிஹெச்.டி. (தத்வஜ்ஞான மாஸ்டர்)',
  ],
  [SupportedLanguage.Odia]: [
    'ଏସ୍‌ଏସ୍‌ସି (ମାଧ୍ୟମିକ ଶିକ୍ଷା ସନଦ)',
    'ଏଚ୍‌ଏସ୍‌ସି (ଉଚ୍ଚମାଧ୍ୟମିକ ଶିକ୍ଷା ସନଦ)',
    'ଡିପ୍ଲୋମା',
    'ବିଏ (କଳାର ସ୍ନାତକ)',
    'ବିଏସ୍‌ସି (ବିଜ୍ଞାନ ସ୍ନାତକ)',
    'ବିକମ୍ (ବାଣିଜ୍ୟ ସ୍ନାତକ)',
    'ବିଟେକ୍ (ପ୍ରଯୁକ୍ତି ବିଜ୍ଞାନ ସ୍ନାତକ)',
    'ବିଇ (ଯନ୍ତ୍ରାବଳି ସ୍ନାତକ)',
    'ଏମ୍‌ବିବିଏସ୍ (ଚିକିତ୍ସା ବିଜ୍ଞାନ ସ୍ନାତକ)',
    'ବିଡିଏସ୍ (ଦନ୍ତ ଚିକିତ୍ସା ବିଜ୍ଞାନ ସ୍ନାତକ)',
    'ବିଆର୍ଚ୍ (ସ୍ଥପତ୍ୟ ସ୍ନାତକ)',
    'ଏମ୍‌ଏ (କଳାର ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌ଏସ୍‌ସି (ବିଜ୍ଞାନ ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌କମ୍ (ବାଣିଜ୍ୟ ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌ଟେକ୍ (ପ୍ରଯୁକ୍ତି ବିଜ୍ଞାନ ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌ଇ (ଯନ୍ତ୍ରାବଳି ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌ବିଏ (ବ୍ୟବସାୟ ପ୍ରଶାସନ ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌ଡି (ଚିକିତ୍ସା ବିଜ୍ଞାନ ସ୍ନାତକୋତ୍ତର)',
    'ଏମ୍‌ଏସ୍ (ଶଲ୍ୟଚିକିତ୍ସା ବିଶେଷଜ୍ଞ ସ୍ନାତକୋତ୍ତର)',
    'ପିଏଚ୍‌ଡି (ଦାର୍ଶନିକତାର ଡ଼କ୍‌ଟରେଟ୍)',
  ],
  [SupportedLanguage.Malayalam]: [
    'എസ്എസ്സി (സെക്കണ്ടറി സ്കൂൾ സർട്ടിഫിക്കറ്റ്)',
    'എച്ച്എസ്സി (ഹയർ സെക്കണ്ടറി സർട്ടിഫിക്കറ്റ്)',
    'ഡിപ്ലോമ',
    'ബി.എ. (ബാച്ചിലർ ഓഫ് ആർട്സ്)',
    'ബി.എസ്സി (ബാച്ചിലർ ഓഫ് സയൻസ്)',
    'ബി.കോം (ബാച്ചിലർ ഓഫ് കൊമേഴ്സ്)',
    'ബി.ടെക് (ബാച്ചിലർ ഓഫ് ടെക്നോളജി)',
    'ബി.ഇ. (ബാച്ചിലർ ഓഫ് എഞ്ചിനീയറിംഗ്)',
    'എംബിബിഎസ് (ബാച്ചിലർ ഓഫ് മെഡിസിൻ, ബാച്ചിലർ ഓഫ് സർജറി)',
    'ബിഡിഎസ് (ബാച്ചിലർ ഓഫ് ഡെന്റൽ സർജറി)',
    'ബി.ആർക്ക് (ബാച്ചിലർ ഓഫ് ആർക്കിടെക്ചർ)',
    'എം.എ. (മാസ്റ്റർ ഓഫ് ആർട്സ്)',
    'എം.എസ്സി (മാസ്റ്റർ ഓഫ് സയൻസ്)',
    'എം.കോം (മാസ്റ്റർ ഓഫ് കൊമേഴ്സ്)',
    'എം.ടെക് (മാസ്റ്റർ ഓഫ് ടെക്നോളജി)',
    'എം.ഇ. (മാസ്റ്റർ ഓഫ് എഞ്ചിനീയറിംഗ്)',
    'എംബിഎ (മാസ്റ്റർ ഓഫ് ബിസിനസ് അഡ്മിനിസ്ട്രേഷൻ)',
    'എം.ഡി. (ഡോക്ടർ ഓഫ് മെഡിസിൻ)',
    'എം.എസ് (മാസ്റ്റർ ഓഫ് സർജറി)',
    'പിഎച്ച്.ഡി. (ഡോക്ടർ ഓഫ് ഫിലോസഫി)',
    'ഐടിഐ (ഇൻഡസ്ട്രിയൽ ട്രെയിനിംഗ് ഇൻസ്റ്റിറ്റ്യൂട്ട്)',
    'പോളിടെക്നിക്',
    'ബിബിഎ (ബാച്ചിലർ ഓഫ് ബിസിനസ് അഡ്മിനിസ്ട്രേഷൻ)',
    'ബി.എഡ് (ബാച്ചിലർ ഓഫ് എഡ്യൂക്കേഷൻ)',
    'എൽഎൽബി (ബാച്ചിലർ ഓഫ് ലോസ്)',
    'ബി.ഫാർം (ബാച്ചിലർ ഓഫ് ഫാർമസി)',
    'ബിഎച്ച്എംഎസ് (ബാച്ചിലർ ഓഫ് ഹോമിയോപ്പതി മെഡിസിൻ ആൻഡ് സർജറി)',
    'ബിഎഎംഎസ് (ബാച്ചിലർ ഓഫ് ആയുർവേദ മെഡിസിൻ ആൻഡ് സർജറി)',
    'ബിയുഎംഎസ് (ബാച്ചിലർ ഓഫ് യുനാനി മെഡിസിൻ ആൻഡ് സർജറി)',
    'ബി.വി.എസ്സി (ബാച്ചിലർ ഓഫ് വെറ്ററിനറി സയൻസ്)',
    'ഡി.ഫാർം (ഡിപ്ലോമ ഇൻ ഫാർമസി)',
    'ജിഎൻഎം (ജനറൽ നേഴ്സിംഗ് ആൻഡ് മിഡ്വൈഫറി)',
    'എഎൻഎം (ഓക്സിലറി നേഴ്സ് മിഡ്വൈഫ്)',
    'ഡിഎംഎൽടി (ഡിപ്ലോമ ഇൻ മെഡിക്കൽ ലബോറട്ടറി ടെക്നോളജി)',
    'ബിപിടി (ബാച്ചിലർ ഓഫ് ഫിസിയോതെറപ്പി)',
    'എംപിടി (മാസ്റ്റർ ഓഫ് ഫിസിയോതെറപ്പി)',
    'എം.എഡ് (മാസ്റ്റർ ഓഫ് എഡ്യൂക്കേഷൻ)',
    'എൽഎൽഎം (മാസ്റ്റർ ഓഫ് ലോസ്)',
    'എം.ഫാർം (മാസ്റ്റർ ഓഫ് ഫാർമസി)',
    'ഡി.ലിറ്റ് (ഡോക്ടർ ഓഫ് ലിറ്ററേച്ചർ)',
    'ഡി.എസ്സി (ഡോക്ടർ ഓഫ് സയൻസ്)'
  ]
}
